import { FormControl, Grid } from "@mui/material";
import { ButtonCancel } from "components/buttons";
import { ButtonApplyFilter } from "components/buttons/ButtonApplyFilter";
import { MprcInputStyles } from "components/filter/MprcInputStyles";
import { AutoCompleteDataModel, AutoCompleteSuggestions, MprcAutoComplete } from "components/MprcAutoComplete";
import { useSession } from "providers/SessionProvider";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { IAdvFilterPickerProps, IAdvFilterResult } from "views/general/AdvancedFilter/interfaces";

////////////////////////////////////////////////////////////////////////////////

export const LanguagePicker: React.FC<IAdvFilterPickerProps> = (props) => {

    const { filter, onApply, onCancel } = props;

    const session = useSession();
    const { t } = useTranslation("shared");
    const multiSelect = filter.canRepeat ?? false;

    const [selected, setSelected] = useState<AutoCompleteDataModel[]>([]);

    const inputRef = useRef<any>(undefined);
    const items = useRef<AutoCompleteDataModel[]>(session.config.inputLocales.map(l => ({
        key: l.locale,
        label: l.nameR.find(x => x.locale == session.uiCulture)?.text ?? l.name,
        canDelete: true,
    })));

    ////////////////////////////////////////////////////////////////////////////////

    ///
    const getSuggestions = (searchText: string, pageNumber: number, pageSize: number): Promise<AutoCompleteSuggestions<AutoCompleteDataModel>> => {
        searchText = searchText.toLowerCase();
        return new Promise<AutoCompleteSuggestions<AutoCompleteDataModel>>((resolve) => {
            const filterItems = searchText.length > 0
                ? items.current.filter(opt => opt.label.toLowerCase().includes(searchText))
                : [...items.current];

            resolve({
                items: filterItems,
                totalRows: filterItems.length
            });
        });
    };

    ///
    const handleApply = () => {
        if (selected.length > 0) {
            const newFilter = selected.map(item => {
                const nameR = session.config.inputLocales.find(x => x.locale == item.key)?.nameR;
                const newFilter: IAdvFilterResult = {
                    command: filter!.command,
                    optionalGroup: filter?.optionGroup,
                    text: `${filter?.displayName.replace("...", "")}: ${nameR?.find(x => x.locale == session.uiCulture)?.text ?? item.label}`,
                    value: item.key,
                    quickFilter: null,
                    period: null,
                    range: null,
                    includeDescendants: null
                };
                return newFilter;
            });
            onApply(newFilter, filter);
        }
    };

    ///
    useEffect(() => {
        (inputRef as any)?.current?.focus();
    }, [inputRef]);

    ////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////

    return (
        <Grid container alignItems="flex-end" spacing={2}>
            <Grid size="grow">
                <FormControl fullWidth>
                    <MprcAutoComplete
                        label={filter.placeholder ?? t(`AdvFilter.Picker.Language.Placeholder${multiSelect ? "_multi" : ""}`)}
                        id="language"
                        fullWidth
                        autoFocus
                        multiSelect={multiSelect}
                        inputRef={inputRef}
                        selectedItems={selected}
                        onChange={(items) => setSelected(items)}
                        onGetSuggestions={getSuggestions}
                        onApply={handleApply}
                        onCancel={onCancel}
                        sx={MprcInputStyles.filter}
                    />
                </FormControl>
            </Grid>
            <Grid>
                <ButtonApplyFilter
                    variant="text"
                    disabled={selected.length == 0}
                    onClick={handleApply}
                />
                <ButtonCancel
                    variant="text"
                    onClick={onCancel}
                />
            </Grid>
        </Grid>
    );
};
